module.exports = __webpack_public_path__ + "static/img/200280.eb8c122a.png";